import React, { useEffect, useState } from 'react'
import {
    UserGroupIcon,
    ChatBubbleOvalLeftEllipsisIcon,
    ChartBarIcon,
} from "@heroicons/react/24/solid";
import { Card, CardContent } from '../../ui/Card';
import { Badge } from '../../ui/Badge';


const Stats = ({ subscribers, newMessages }) => {
    const [metrics, setMetrics] = useState(0);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const selectedRange = "7d";

                fetch(`${process.env.REACT_APP_BACKEND_URL}/analytics/analytics-summary?range=${selectedRange}`)
                    .then((res) => res.json())
                    .then((data) => setMetrics(data.totalPageViews.value));
            } catch (error) {
                console.error('Veri çekilirken hata oluştu:', error);
            }
        };
        fetchData();
    }, []);
    const statCards = [
        {
            id: "subscribers",
            title: "Toplam Abone",
            value: subscribers,
            icon: <UserGroupIcon className="w-6 h-6 text-background" />,
        },
        {
            id: "newMessages",
            title: "Yeni Mesajlar",
            value: newMessages,
            icon: <ChatBubbleOvalLeftEllipsisIcon className="w-6 h-6 text-background" />,
        },
        {
            id: "visits",
            title: "Bu Hafta Ziyaret",
            value: metrics,
            icon: <ChartBarIcon className="w-6 h-6 text-background" />,
        },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {statCards.map((metric, index) => {

                return (
                    <Card key={index} className="shadow-shadowElegant hover:shadow-shadowGlow transition-all duration-300">
                        <CardContent className="p-6">
                            <div className='flex items-center justify-between'>
                                <div>
                                    <p className="text-sm font-medium text-mutedForeground">{metric.title}</p>
                                    <p className="text-2xl font-bold">{metric.value}</p>
                                    <div className="flex items-center mt-4">
                                    </div>
                                </div>
                                <div className="bg-gradientPrimary p-3 rounded-lg">
                                    {metric.icon}
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                );
            })}
        </div>
    )
}

export default Stats
